var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owl-carrusel"},[_c('carousel',{attrs:{"items":1,"nav":false,"dots":false,"autoplay":true,"loop":true}},_vm._l((24),function(idx){return _c('img',{key:idx,attrs:{"src":`https://photo-public.s3.amazonaws.com/suf/sliders/home/sitio-unificado-foto-${idx}.jpg`}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }